<div class="en" *ngIf="localService.languageContent">
  <div class="banner center" style="max-width:1000px;">
    <div *ngIf="wrapper" class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper.items">
        <div class="col-12">
          <div>{{item.v3 | localDate}}&nbsp;:&nbsp;{{item.v1}}</div>
          <div>{{item.v2}}</div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="wrapper" [paging]="wrapper.paging" [IsSimple]="true" [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
